import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Provider from "./authcontext/AuthProvider";
import Routes from "./Routes";

const Root = () => (
  <Router>
    <Provider>
      <Routes />
      <Toaster />
    </Provider>
  </Router>
);

export default Root;
